import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

const selectOrder = (state: RootState) => state.order;

const selectOrderValues = createSelector(
  selectOrder,
  ({ subtotal, tax, total }) => ({
    subtotal:
      subtotal && subtotal.length
        ? parseInt((Number(subtotal) * 100).toFixed(0))
        : null,
    tax: tax && tax.length ? parseInt((Number(tax) * 100).toFixed(0)) : null,
    total:
      total && total.length
        ? parseInt((Number(total || 0) * 100).toFixed(0))
        : null,
  })
);

const selectCurrentTransactionId = createSelector(
  selectOrder,
  (order) => order.currentTransactionId
);
const selectTransactions = createSelector(
  selectOrder,
  (order) => order.transactions
);
const selectOrderError = createSelector(
  selectOrder,
  (order) => order.orderError
);
const selectIsPosmonDisconnected = createSelector(
  selectOrder,
  (order) => order.isPosmonDisconnected
);

const selectIsPosmonReconnected = createSelector(
  selectOrder,
  (order) => order.isPosmonReconnected
);

const selectCurrentTransactionCoupons = createSelector(
  selectOrder,
  (order) => order.currentTransactionCoupons
);

const selectCurrentTransactionLoyalties = createSelector(
  selectOrder,
  (order) => order.currentTransactionLoyalties
);

// The most recent order request (the only one whose check event is processed —
// see the orderSlice `messageReceived` handler), or undefined when none exist.
const selectLatestOrderRequest = createSelector(selectOrder, (order) => {
  const lastRequestId = order.requestsOrder.length
    ? order.requestsOrder[order.requestsOrder.length - 1]
    : '';
  return lastRequestId ? order.requestsById[lastRequestId] : undefined;
});

const selectLastHITLOrderId = createSelector(selectOrder, (order) => {
  const lastOrderRequest = order.requestsOrder.length
    ? order.requestsOrder[order.requestsOrder.length - 1]
    : '';
  return order.requestsById[lastOrderRequest]?.orderId;
});

const selectOrderErrorCartItemId = createSelector(
  selectOrder,
  (order) => order.errorCartItemId
);

const selectMenuModuleCartErrors = createSelector(
  selectOrder,
  (order) => order.menuModuleCartErrors
);

const selectFinalOrderStatus = createSelector(
  selectOrder,
  (order) => order.finalOrderStatus
);

// Get check event items from the order state
const selectCheckEventItems = createSelector(
  selectOrder,
  (order) => order.checkEventItems
);

// Get customer name from the order state
const selectCustomerName = createSelector(
  selectOrder,
  (order) => order.customerName
);

export {
  selectOrder,
  selectOrderValues,
  selectCurrentTransactionId,
  selectTransactions,
  selectOrderError,
  selectIsPosmonDisconnected,
  selectIsPosmonReconnected,
  selectCurrentTransactionCoupons,
  selectCurrentTransactionLoyalties,
  selectLatestOrderRequest,
  selectLastHITLOrderId,
  selectOrderErrorCartItemId,
  selectMenuModuleCartErrors,
  selectFinalOrderStatus,
  selectCheckEventItems,
  selectCustomerName,
};
